const CLEAR_VARS = [
    'eVar13', 'prop25', 'eVar28', 'prop26', 'prop27',
    'prop28', 'prop29', 'prop30', 'prop32', 'prop33',
    'prop34', 'prop43', 'prop49', 'eVar49', 'prop54'
];

const getOrientation = function () {
    const width = window.innerWidth || document.documentElement.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight;
    const orientation = (height >= width) ? 'Portrait' : 'Landscape';
    return orientation;
};

const capitalize = function (str) {
    return str.charAt(0).toUpperCase() + str.substr(1);
};

const clearVideoVars = function (s) {
    // Clear each of the props.
    for (const prop in CLEAR_VARS) {
        if (Object.prototype.hasOwnProperty.call(CLEAR_VARS, prop)) {
            delete s[CLEAR_VARS[prop]];
        }
    }
    delete s.events;
};

// Tracking async function which will fire on player events
const trackAsync = function (asyncSProps) {
    const teamId = (window.teamId !== 'milb') ? window.teamId : '';
    const env = window.env || 'production';
    const reportingSuiteId = env === 'production' ? `milbglobal,milb${teamId}` : `mlbdevmilbglobal${teamId}`;
    const trackingTitle = window.pageMeta && window.pageMeta.omniturePageName;
    const s = window.s_gi && window.s_gi(reportingSuiteId);
    const { clipData = {} } = window;
    const title = clipData.title || '';
    const slug = clipData.slug || '';
    let homeTeamId;
    let awayTeamId;
    let gamePk;
    let sponsoredTags = '';
    const gamePkObject = clipData.keywordsAll && clipData.keywordsAll.find((keyword) => keyword.type === 'game_pk');

    if (gamePkObject) {
        gamePk = gamePkObject.value;
        const displayName = gamePkObject.displayName || '';
        const teams = displayName.match(/T\d{3,4}/g);
        homeTeamId = teams[0] && teams[0].replace('T', '');
        awayTeamId = teams[1] && teams[1].replace('T', '');
    }

    if (clipData.keywordsAll && clipData.keywordsAll.length > 0) {
        sponsoredTags = clipData.keywordsAll.reduce((result, item, index) => {
            return index === 0 ? item.slug : `${result},${item.slug}`;
        }, '');
    }

    if (s) {
        s.clearVars();
        clearVideoVars(s);
        s.linkTrackEvents += ',event67,event68,event69'; // Tell tracking suite to keep track of percentage play events
        s.eVar24 = sponsoredTags;
        s.eVar52 = gamePk;
        s.eVar57 = awayTeamId;
        s.eVar58 = homeTeamId;
        s.eVar73 = reportingSuiteId;
        s.eVar187 = title;
        s.eVar189 = slug;
        s.prop11 = 'Dynamic Page View';
        s.prop13 = asyncSProps.prop13 || trackingTitle;
        s.prop15 = `${capitalize(window.getStartupDeviceTypeString())}: ${getOrientation()}`;
        s.prop22 = (s.Util.cookieRead('oktaid')) || null;
        for (const prop in asyncSProps) {
            if (Object.prototype.hasOwnProperty.call(asyncSProps, prop)) {
                s[prop] = asyncSProps[prop];
            }
        }
        // (my): Intentional to be after for loop to override value in asyncSProps
        s.prop27 = 'Video';
        // async call
        s.tl(true, 'o', 'http://myGenericURL');

    }
};

export default trackAsync;
